import React, { Fragment } from 'react'
import { useMedia } from 'sb-hooks'

import Carousel from 'components/ui/Carousel/Carousel'
import { Loader, UpchargePrice, ImageWithPlaceholderFallback } from 'components/_new/ui'

import s from './ProductImagesWithName.scss'


const Picture = ({ className, src, alt, isMobile }) => (
  <ImageWithPlaceholderFallback
    className={className}
    src={src}
    w={isMobile ? 316 : 270}
    alt={alt || 'product'}
  />
)

const carouselOptions = {
  arrows: false,
  dots: true,
  swipe: true,
  touchMove: true,
}

const ProductImagesWithName = (props) => {
  const { img, brand, name, upchargePrice, media, mediaCount } = props
  const { isMobile } = useMedia()

  return (
    <Fragment>
      <div className={s.container}>
        <Loader className={s.loader} />
        {
          Boolean(media.length) ? (
            <Carousel className={s.image} options={carouselOptions}>
              {
                media.slice(0, mediaCount).map(({ preview }, index) => (
                  <Picture key={index} src={preview} isMobile={isMobile} />
                ))
              }
            </Carousel>
          ) : (
            <Picture className={s.image} src={img} isMobile={isMobile} />
          )
        }
      </div>
      <div className={s.title}>
        <span className={s.brand}>
          {brand}
          {
            Boolean(upchargePrice) && (
              <UpchargePrice className={s.upchargePrice} price={upchargePrice} />
            )
          }
        </span>
        <br />
        {name}
      </div>
    </Fragment>
  )
}

ProductImagesWithName.defaultProps = {
  media: [],
  mediaCount: 5, // this number is handpicked for carousel to look good
}


export default ProductImagesWithName
